const vehicleCategories = {
    CAR: "CAR",
    TRUCK: "TRUCK",
    VAN: "VAN",
    COMMERCIALVAN: "COMMERCIAL VAN",
    SUV: "SUV",
    MOTORHOME: "MOTOR HOME",
    SEMI: "SEMI",
};

export { vehicleCategories };
